require('jquery-lazy');

$(window).bind('load', () => {

  lazyInstance = $('.lazy').lazy({
      attribute: 'data-srcset',
      chainable: false,
      effect: 'fadeIn',
      effectTime: 100,
      afterLoad: function(e) {

        // setTimeout(() => {
        
        //   console.log($(e).attr('style').search('opacity: 0.'), 'loaded')
        
        // }, 1000);

      }
  });

});

window.lazyOverseer = function(e) {

  if(e.find('.lazy').length) {

    setTimeout(() => {

      e.find('.lazy').lazy({
        attribute: 'data-srcset',
        chainable: false,
        effect: 'fadeIn',
        effectTime: 100
      });

      e.find('.lazy').removeAttr('style')

    }, 2000);

  }

}